/**
 * Returns true when an error is an aborted/cancelled request (axios
 * `CanceledError` / fetch `AbortError`) rather than a real failure — so callers
 * can distinguish a superseded request from a genuine error.
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export function isCanceledError(error) {
    return (
        error?.code === 'ERR_CANCELED' ||
        error?.name === 'CanceledError' ||
        error?.name === 'AbortError'
    );
}
